import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'semantic-ui-react/dist/es/modules/Transition';
import 'semantic-ui-css/components/transition.min.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
const isMobile = isMobileDevice();

import Modal from './Modal.jsx';

class FlyUpModal extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);

        this.state = {
            visible: false
        };
    }

    componentDidMount() {
        this.setState({
            visible: true
        });
    }

    onClose() {
        if(this.props.QuizExitClicked) {
            this.props.QuizExitClicked();
        }
        this.setState({
            visible: false
        });
    }

    render() {
        const visible = this.props.open === null ? this.state.visible : (this.state.visible && this.props.open);
        const extraClassName = this.props.extraClassName;
        const modalWrapperClassName = extraClassName ? 'modalWrapper ' + extraClassName : 'modalWrapper';
        const hotspotroomId = this.props.roomId+"-"+this.props.hotspotId;
        var modalWrapperClassNameWidth;
        if(hotspotroomId == '614a6aa5d7bb008cbec58ca9-614b39776dbab91a18aaeb65' && !isMobile)
            modalWrapperClassNameWidth = {'maxWidth' : '40vw'};
        else 
            modalWrapperClassNameWidth = {};

        return (
            <React.Fragment>
                <Transition
                    animation={'fly up'}
                    duration={this.props.duration}
                    visible={visible}
                    unmountOnHide={true}
                    onComplete={this.props.onModalOpened}
                    onHide={this.props.onModalHidden}
                >
                    <div className='modalContainer'>
                        <div className={modalWrapperClassName} style={modalWrapperClassNameWidth}>
                            <Modal onClose={this.onClose} isOpaque={this.props.isOpaque}  isImageLoaded={this.props.isImageLoaded}>
                                {this.props.children}
                            </Modal>
                        </div>
                    </div>
                </Transition>
            </React.Fragment>
        );
    }
}

FlyUpModal.propTypes = {
    open: PropTypes.bool,
    extraClassName: PropTypes.string,
    onModalHidden: PropTypes.func,
    onModalOpened: PropTypes.func,
    isOpaque: PropTypes.bool,
    hotspotId: PropTypes.string
};

FlyUpModal.defaultProps = {
    duration: 700
}

export default FlyUpModal;
